import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'

import Loading from '../common/modal/Loading';
import FormTemplate from "../common/form/FormTemplate";
import LoginTop from "../top/LoginTop";
import axios from "axios";
import configData from "../../config/config.json";
import Footer from '../bottom/Footer'
import { ALERT_TYPES, LOADING_STATUES } from "../constants/constants";
import Alert from '../common/modal/Alert';

class CompleteRegistration extends React.Component {
	state = {
		pageHeading: 'Registration Incomplete',
		fullName: '',
		username: '',
		message: '',
		loadingStatus: "",
		errors: {},
		showAlert: false,
		redirectToLogin: false
	}

	showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	componentDidMount() {
		var ticket = { ticket: this.props.match.params.ticket };
		axios.post(configData.LANDNOTIFICATION_SERVER_URL + "auth/completeRegistration", ticket, { withCredentials: true })
			.then((response) => {
				this.setState({ pageHeading: 'Finalize Registration', message: 'Click on Continue to complete registration.' });
			}, (error) => {
				this.setState({ status: "", redirectToLogin: false, message: error.response.data.message });
			});

	}

	handleSubmit = (event) => {
		event.preventDefault();
		var ticket = { ticket: this.props.match.params.ticket };
		axios.post(configData.LANDNOTIFICATION_SERVER_URL + "auth/completeRegistration2", ticket, { withCredentials: true })
			.then((response) => {
				this.setState({
					username: response.data.content.username,
					fullName: response.data.content.fullName,
					showAlert: true
				});
			}, (error) => {
			});
	}

	hideAlert = () => {
		this.setState({
			showAlert: false,
		})

		this.props.history.push('/login');
	}

	render() {

		let formGroupRows = [
			{
				formGroups: [{ id: 'messageLabel', fieldType: 'label', value: this.state.message }]
			}
		]

		const formProps = {
			componentName: "CompleteRegistration",
			pageHeading: this.state.pageHeading,
			onSubmit: this.handleSubmit,
			primaryButtonLabel: "Continue",
			formGroupRows: formGroupRows,
			formOnly: true
		}

		return (
			<div key={this.props.match.params.ticket}>
				<LoginTop />
				<section className="cn container-fluid" style={{ background: '#145A7B' }}>
					<div style={{ background: 'white', border: 'solid 3px black', borderRadius: 5, paddingBottom: 10, paddingLeft: 10, paddingRight: 5 }}>
						<Container fluid="true" >
							<Row>
								<Col>
									<FormTemplate {...formProps} />
								</Col>
							</Row>
						</Container>
					</div>
				</section>
				<Footer />
				<Loading loadingIndicator={this.state.status === LOADING_STATUES.LOADING} />
				<Alert type={ALERT_TYPES.OK} show={this.state.showAlert} hideAlert={this.hideAlert} message={'Welcome, ' + this.state.fullName + '!  You may continue to log in with your username, ' + this.state.username + '.'} />
			</div>
		)
	}
}

export default CompleteRegistration;